import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Card } from "@/components/ui/card";

export default function AdminCancellations() {
  const [rows, setRows] = useState([]);
  useEffect(() => { (async () => { const { data } = await api.get("/admin/cancellations"); setRows(data); })(); }, []);
  return (
    <div>
      <h1 className="font-heading text-3xl font-semibold text-[var(--brand-accent)]">Cancellations</h1>
      <p className="text-slate-500 mt-1">Refund-eligible cancelled bookings.</p>
      <Card className="mt-6 overflow-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Booking</TableHead><TableHead>Amount</TableHead>
              <TableHead>Reason</TableHead><TableHead>Date</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map((c) => (
              <TableRow key={c.id} data-testid={`admin-cancellation-${c.id}`}>
                <TableCell className="font-mono text-xs">{c.booking_id.slice(0, 8)}</TableCell>
                <TableCell className="font-semibold">${Number(c.amount).toFixed(2)} {c.currency}</TableCell>
                <TableCell>{c.reason}</TableCell>
                <TableCell className="text-xs text-slate-500">{new Date(c.created_at).toLocaleString()}</TableCell>
              </TableRow>
            ))}
            {rows.length === 0 && <TableRow><TableCell colSpan={4} className="text-center text-slate-400 py-10">No cancellations</TableCell></TableRow>}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
